/**
 * W3C trace headers for a client-side request to the backend, gated by the SAME
 * rule the `$api` choke point applies in `app/plugins/01.api.ts` (onRequest):
 *
 * - Same-origin (SSR proxy / dev) — always safe to trace.
 * - Cross-origin (static mode → the .NET backend) — trace ONLY when
 *   `NUXT_PUBLIC_FROGGER_TRACE_BACKEND=1`. Otherwise the browser preflight blocks
 *   the request, because the backend must first allowlist `traceparent`/`tracestate`
 *   in `Access-Control-Allow-Headers`.
 *
 * This is the single source of truth for that gate so a CORS-policy change updates
 * one place instead of drifting across call sites (which is how the preflight block
 * gets reintroduced).
 *
 * Call this INSIDE the enclosing `frogger.span(...)` so the emitted `traceparent`
 * parents under that span, then attach the result as the request `headers`.
 *
 * Used by the PRE-AUTH endpoints (login / logout / refresh / 2FA) which deliberately
 * use raw `$fetch` + this helper rather than `$api` — `$api`'s 401 interceptor
 * (refresh + retry + forceLogout) would corrupt the error handling those flows parse.
 */
export function useTraceHeaders(): Record<string, string> {
	const { isStaticMode } = useStaticMode();
	const froggerTraceBackend = Boolean(useRuntimeConfig().public.froggerTraceBackend);
	return !isStaticMode || froggerTraceBackend ? frogger.getHeaders() : {};
}
